<template>
  <div class="top-container" @touchmove.prevent @click="closeFilter()">
    <div class="top-container-content">
      <div class="filter">
        <div class="tip">优惠</div>
        <div class="filter-content">
          <div :class="classArray.quan.className[0]" @click.stop="addParam(classArray.quan.type,0,'&dpyhq=false')">全部商品</div>
          <div :class="classArray.quan.className[1]" @click.stop="addParam(classArray.quan.type,1,'')">有券商品</div>
        </div>
      </div>
      <div class="filter" v-if="!isWeixin">
        <div class="tip">店铺</div>
        <div class="filter-content">
          <div :class="classArray.shop.className[0]" @click.stop="addParam(classArray.shop.type,0,'')">全部</div>
          <div :class="classArray.shop.className[1]" @click.stop="addParam(classArray.shop.type,1,'&tmall=true')">天猫</div>
        </div>
      </div>
      <div class="filter" v-else>
        <div class="tip">店铺</div>
        <div class="filter-content">
          <div :class="classArray.shop.className[0]" @click.stop="addParam(classArray.shop.type,0,'')">全部</div>
          <div :class="classArray.shop.className[1]" @click.stop="addParam(classArray.shop.type,1,'&jd_only=1')">京东</div>
        </div>
        <div class="filter-content">
          <div :class="classArray.shop.className[2]" @click.stop="addParam(classArray.shop.type,2,'&pdd_only=1')">拼多多</div>
          <div class="item-right-null"></div>
        </div>
      </div>
      <div class="filter">
        <div class="tip">价格</div>
        <div class="filter-content">
          <div :class="classArray.price.className[0]" @click.stop="addParam(classArray.price.type,0,'&endprice=10')">小于10元</div>
          <div :class="classArray.price.className[1]" @click.stop="addParam(classArray.price.type,1,'&startprice=10&endprice=20')">10-20元</div>
        </div>
        <div class="filter-content">
          <div :class="classArray.price.className[2]" @click.stop="addParam(classArray.price.type,2,'&startprice=20&endprice=50')">20-50元</div>
          <div :class="classArray.price.className[3]" @click.stop="addParam(classArray.price.type,3,'&startprice=50')">50元以上</div>
        </div>
        <div class="filter-content">
          <div :class="classArray.price.className[4]" @click.stop="addParam(classArray.price.type,4,'')">全部</div>
          <div class="item-right-null"></div>
        </div>
      </div>

      <div class="filter" @click="addParam">
        <div class="filter-content">
          <div class="item-center">重置</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'filter',
    props:['resert'],
    data(){
      var left = 'item-left';
      var right = 'item-right';
      return {
        param:'',
        left:'item-left',
        right:'item-right',
        leftActive:'item-left active',
        rightActive:'item-right active',
        classArray:{
          quan:{
            className:[left,right],
            param:'',
            type:1
          },
          shop:{
            className:[left,right,left],
            param:'',
            type:2
          },
          price:{
            className:[left,right,left,right,left],
            param:'',
            type:3
          }
        }
      }
    },
    mounted(){
      this.public.filterParam='dpyhq=false';
    },
    watch:{
      'resert':function(r){
        this.addParam();
      }
    },
    methods:{
      handleClass(type,index,str){
        var selt = this;
        var handlOneClass = function(arr){
          return arr.map(function(item,idx,array){
            if(idx==index){
              return idx%2==0?selt.leftActive:selt.rightActive;
            }else{
              return idx%2==0?selt.left:selt.right;
            }
          });
        };
        switch (type){
          case this.classArray.quan.type:{
            this.classArray.quan.className = handlOneClass(this.classArray.quan.className);
            this.classArray.quan.param = str;
            break;
          }
          case this.classArray.shop.type:{
            this.classArray.shop.className = handlOneClass(this.classArray.shop.className);
            this.classArray.shop.param = str;
            break;
          }
          case this.classArray.price.type:{
            this.classArray.price.className = handlOneClass(this.classArray.price.className);
            this.classArray.price.param = str;
            break;
          }
          default:{
            this.classArray.quan.className = [this.left,this.right];
            this.classArray.quan.param = '';
            this.classArray.shop.className = [this.left,this.right];
            this.classArray.shop.param = '';
            this.classArray.price.className = [this.left,this.right,this.left,this.right,this.left];
            this.classArray.price.param = '';
          }
        }
      },
      addParam(type,index,str){
        var isResert = false;
        if(typeof str == 'undefined'){
          isResert = true;
        }
        this.handleClass(type,index,str);
        this.public.filterParam = this.classArray.quan.param+this.classArray.shop.param+this.classArray.price.param;
        this.public.pageNumParam = '';
        this.public.toggleReload();
        this.watcher.$emit('closeAndSearchFilter',isResert);
      },
      closeFilter(){
        this.watcher.$emit('closeAndSearchFilter',false,true);
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Filter.vue?bb457d80